import React from 'react';
import PropTypes from 'prop-types';
import formatMessage from 'format-message';
import * as searchPaths from '../../constants/search-paths';
import * as paginatedPageSizes from '../../constants/paginated-page-sizes';
import { createFetchResults } from '../../common/util/create-fetch-results';
import { SORTING_ORDER_ASCENDING, SORTING_ORDER_DESCENDING } from '../../constants/search';
import { hasActiveSearch } from '../../common/util/search-query-utils';

// Components
import SearchResultsWrapper from './results/wrapper';
import PreviewCardWrapper from '../resources/preview-card-wrapper';
import NoResult from '../common/no-result';

// Stores
import ResultsStore from '../../stores/results';

export default class ImportedHandler extends React.Component {
  static isResultView = true

  static propTypes = {
    session: PropTypes.object,
    sortBy: PropTypes.string,
    sortOrder: PropTypes.oneOf([SORTING_ORDER_ASCENDING, SORTING_ORDER_DESCENDING]),
  }

  onCardRender (resource) {
    return (
      <PreviewCardWrapper
        accountSettings={this.props.account && this.props.account.settings}
        allowApprovedContent={this.props.session.allowApprovedContent}
        accountId={this.props.session.accountId}
        available={resource.available === undefined ? true : resource.available}
        resource={resource}
      />
    );
  }

  render () {
    const { session, results } = this.props;

    const hasImported = Boolean(results.total);

    const noResultsMessage = results.total
      ? formatMessage('No Results Found')
      : formatMessage('No Imported Resources');

    const resultsPerPage = paginatedPageSizes.IMPORTED_PAGE_SIZE;
    const fetchResults = createFetchResults(searchPaths.RESOURCES, resultsPerPage);

    const showSuggestions = hasImported && hasActiveSearch(this.props.router.query);

    return (
      <SearchResultsWrapper
        baseParams={{
          onlyImported: true
        }}
        fetchResults={fetchResults}
        resultsPerPage={resultsPerPage}
        queryArialLabel={formatMessage(
          'Search My Imported Resources for course resources by keyword, author, institution, or title'
        )}
        isLoading={ResultsStore.showLoading()}
        searchPrivateObjects
        emptyMessage={
          <NoResult
            title={noResultsMessage}
            showSuggestions={showSuggestions}
            message={
              !hasImported &&
              formatMessage(
                'Import resources from Commons by clicking the "Import/Download" button in the Resource details page.'
              )
            }
          />
        }
        canShowPublic={!session.publicOnly}
        canToggleLayout={false}
        onCardRender={resource => this.onCardRender(resource)}
        {...this.props}
      />
    );
  }
}
